/**
 * Route for `offer-checker-tool`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { OfferCheckerToolPage } from "../features/offer-checker-tool/OfferCheckerToolPage";

export const offerCheckerToolRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/offer-checker-tool",
	component: OfferCheckerToolPage,
});

export default offerCheckerToolRoute;
